/* Misu Popup Studio runtime v5.6.5 — dependency-free, deferred and failure-safe. */
(function () {
  'use strict';

  // Keep subscription management and order/account pages free of acquisition popups.
  if (/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?(?:policies|a\/account|account|customer_authentication|checkouts?|orders|pages\/(?:manage-subscriptions?|subscription-terms|privacy-choices|contact(?:-us)?|legal|shipping(?:-returns)?|returns-exchanges))(?:\/|$)/i.test(location.pathname)) return;

  var VERSION = '5.6.5';
  var runtimeUrl = document.currentScript && document.currentScript.src;
  var assignmentToken = '';
  var activeExperiment = null;
  var STORAGE_PREFIX = 'misu.popup.';
  var ALLOWED_EVENTS = ['impression', 'engaged', 'game_started', 'game_completed', 'step_completed', 'email_submitted', 'cta_clicked', 'dismissed', 'error'];
  var opened = false;
  var activeCampaign = null;
  var bootstrap = readBootstrap();
  var deliveryInFlight = false;
  var deliveryTimer = 0;
  var deliveryFailures = 0;
  var memoryStorage = {};
  var memoryOnlyKeys = {};

  if (!bootstrap || !bootstrap.enabled || bootstrap.override === 'off') return;

  var query = new URLSearchParams(location.search);
  var forcedTemplate = query.get('misu_popup');
  var forceOpen = query.get('misu_popup_force') === '1' || Boolean(forcedTemplate);
  if (bootstrap.themeEditor && !bootstrap.showInThemeEditor && !forceOpen) return;

  var DEFAULT_CONFIG = {
    schemaVersion: 1,
    version: 1,
    enabled: true,
    updatedAt: '2026-09-04T00:00:00.000Z',
    global: { respectGpc: true, apiTimeoutMs: 1200 },
    campaigns: [{
      id: 'first-box-offer',
      name: 'First box offer',
      enabled: true,
      template: 'offer',
      weight: 100,
      trigger: { type: 'any', conditions: [{ type: 'delay', value: 15 }, { type: 'scroll', value: 65 }] },
      audience: {
        devices: ['mobile', 'desktop'],
        include: ['*'],
        exclude: ['/cart*', '/account*', '/challenge*'],
        excludeCustomers: true,
        requireEmptyCart: true
      },
      frequency: { maxImpressions: 2, windowDays: 14, cooldownHours: 72, suppressAfterConversionDays: 365 },
      content: {
        kicker: 'YOU GET',
        title: '52% OFF',
        titleAccent: '+ 2 FREE GIFTS',
        body: '',
        question: 'What’s your main goal?',
        choices: ['More energy', 'A healthier gut', 'Lose body fat', 'Stay full longer'],
        emailTitle: '52% OFF',
        emailBody: '+ 2 FREE GIFTS',
        successTitle: 'YOUR OFFER IS READY',
        successBody: '',
        cta: 'SHOP THE FIRST BOX'
      },
      design: {
        accent: '#352116',
        surface: '#FBF3DF',
        visual: 'grainTexture',
        layout: 'offerCard',
        background: 'grainTexture',
        overlay: 0,
        scale: 88,
        textTone: 'dark',
        motion: 'fade'
      }
    }]
  };

  function readBootstrap() {
    var node = document.getElementById('MisuPopupBootstrap');
    if (!node) return null;
    try { return JSON.parse(node.textContent); } catch (_) { return null; }
  }

  function storageGet(key, fallback) {
    if (memoryOnlyKeys[key]) return memoryStorage[key];
    try {
      var value = localStorage.getItem(STORAGE_PREFIX + key);
      if (value !== null) { memoryStorage[key] = JSON.parse(value); return memoryStorage[key]; }
    } catch (_) {}
    return Object.prototype.hasOwnProperty.call(memoryStorage, key) ? memoryStorage[key] : fallback;
  }

  function storageSet(key, value) {
    // Private browsing/storage restrictions must not discard the in-page queue.
    memoryStorage[key] = value;
    try { localStorage.setItem(STORAGE_PREFIX + key, JSON.stringify(value)); delete memoryOnlyKeys[key]; }
    catch (_) { memoryOnlyKeys[key] = true; }
  }

  function visitorId() {
    var id = storageGet('visitor', '');
    if (!id) {
      id = (window.crypto && window.crypto.randomUUID)
        ? window.crypto.randomUUID()
        : 'v-' + Math.random().toString(36).slice(2) + Date.now().toString(36);
      storageSet('visitor', id);
    }
    return id;
  }

  function hash(input) {
    var output = 2166136261;
    for (var index = 0; index < input.length; index += 1) {
      output ^= input.charCodeAt(index);
      output = Math.imul(output, 16777619);
    }
    return output >>> 0;
  }

  function escapeHtml(value) {
    return String(value == null ? '' : value).replace(/[&<>'"]/g, function (character) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#39;', '"': '&quot;' }[character];
    });
  }

  function safeColor(value, fallback) {
    return /^#[0-9a-f]{6}$/i.test(String(value || '')) ? value : fallback;
  }

  function globMatches(path, pattern) {
    if (!pattern || pattern === '*') return true;
    var expression = '^' + String(pattern).replace(/[.+?^$\{\}()|[\]\\]/g, '\\$&').replace(/\*/g, '.*') + '$';
    try { return new RegExp(expression, 'i').test(path); } catch (_) { return false; }
  }

  function isMobile() {
    return matchMedia('(max-width: 760px)').matches;
  }

  function eligible(campaign) {
    if (!campaign || !campaign.enabled) return false;
    var audience = campaign.audience || {};
    var context = bootstrap.context || {};
    var device = isMobile() ? 'mobile' : 'desktop';
    if (audience.devices && audience.devices.indexOf(device) === -1) return false;
    if (audience.excludeCustomers && context.customerKnown) return false;
    if (audience.requireEmptyCart && Number(context.cartCount || 0) > 0) return false;
    var path = context.path || location.pathname;
    var includes = audience.include && audience.include.length ? audience.include : ['*'];
    if (!includes.some(function (pattern) { return globMatches(path, pattern); })) return false;
    if ((audience.exclude || []).some(function (pattern) { return globMatches(path, pattern); })) return false;
    var now = Date.now();
    if (campaign.startsAt && now < Date.parse(campaign.startsAt)) return false;
    if (campaign.endsAt && now > Date.parse(campaign.endsAt)) return false;
    if (forceOpen) return true;
    var convertedAt = Number(storageGet('convertedAt', 0));
    var conversionDays = Number((campaign.frequency || {}).suppressAfterConversionDays || 365);
    if (convertedAt && now - convertedAt < conversionDays * 86400000) return false;
    var history = storageGet('history.' + ((campaign.game || {}).controlId || campaign.id), []);
    var windowDays = Number((campaign.frequency || {}).windowDays || 14);
    var current = history.filter(function (stamp) { return now - Number(stamp) < windowDays * 86400000; });
    var max = Number((campaign.frequency || {}).maxImpressions || 2);
    var cooldown = Number((campaign.frequency || {}).cooldownHours || 72) * 3600000;
    return current.length < max && (!current.length || now - current[current.length - 1] >= cooldown);
  }

  function chooseCampaign(config) {
    var candidates = (config.campaigns || []).filter(eligible);
    if (!candidates.length) return null;
    var total = candidates.reduce(function (sum, campaign) {
      return sum + Math.max(0, Number(campaign.weight || 0));
    }, 0) || candidates.length;
    var point = (hash(visitorId() + ':' + String(config.version || 1)) % 10000) / 10000 * total;
    for (var index = 0; index < candidates.length; index += 1) {
      point -= Math.max(0, Number(candidates[index].weight || 0)) || (total === candidates.length ? 1 : 0);
      if (point <= 0) return candidates[index];
    }
    return candidates[candidates.length - 1];
  }

  function configUrl() {
    if (!bootstrap.endpoint) return '';
    var context = bootstrap.context || {};
    return String(bootstrap.endpoint).replace(/\/+$/, '') + '/api/popup-config?brand=misu&shop=' +
      encodeURIComponent(context.shop || location.hostname);
  }

  function loadConfig() {
    var url = configUrl();
    if (!url || !window.fetch) return Promise.resolve(null);
    var controller = 'AbortController' in window ? new AbortController() : null;
    var timeout = setTimeout(function () {
      if (controller) controller.abort();
    }, 5000);
    return fetch(url, {
      method: 'GET',
      mode: 'cors',
      credentials: 'omit',
      cache: 'default',
      signal: controller ? controller.signal : undefined
    }).then(function (response) {
      if (!response.ok) throw new Error('config_' + response.status);
      return response.json();
    }).then(function (payload) {
      activeExperiment = payload.experiment || null;
      var config = payload && payload.config ? payload.config : payload;
      var hasCurrentOffer = config && Array.isArray(config.campaigns) &&
        config.campaigns.some(function (campaign) { return campaign.template === 'offer'; });
      return config && config.schemaVersion === 1 && hasCurrentOffer ? config : null;
    }).catch(function () {
      // A configuration outage must not show an old offer outside an active test.
      return null;
    }).finally(function () {
      clearTimeout(timeout);
    });
  }

  function schedule(campaign) {
    if (!campaign || opened) return;
    var cleanups = [];
    var fired = false;
    function fire(type) {
      if (fired || opened) return;
      fired = true;
      cleanups.forEach(function (cleanup) { cleanup(); });
      // Re-check frequency, customer and cart rules when the condition actually fires.
      var liveCart = (window.Shopify || {}).cart;
      if (liveCart && bootstrap.context) bootstrap.context.cartCount = liveCart.item_count;
      if (eligible(campaign)) prepareGame(campaign).then(function () { if (eligible(campaign)) openPopup(campaign, type); });
    }
    function listen(target, name, listener) {
      target.addEventListener(name, listener, { passive: true });
      cleanups.push(function () { target.removeEventListener(name, listener); });
    }
    if (forceOpen) {
      setTimeout(function () { fire('preview'); }, 100);
      return;
    }
    var trigger = campaign.trigger || { type: 'delay', value: 7 };
    var rules = trigger.type === 'any' && Array.isArray(trigger.conditions) ? trigger.conditions.slice(0, 4) : [trigger];
    rules.forEach(function (rule) {
      if (fired) return;
      var amount = Math.max(0, Number(rule.value || 0));
      var timer;
      cleanups.push(function () { clearTimeout(timer); });
      if (rule.type === 'scroll') {
        var onScroll = function () {
          var total = document.documentElement.scrollHeight - innerHeight;
          if (total > 0 && (scrollY / total) * 100 >= amount) fire('scroll');
        };
        listen(window, 'scroll', onScroll);
        onScroll();
      } else if (rule.type === 'exit') {
        // No mouse exit intent on touch devices; other OR conditions remain active.
        if (isMobile()) return;
        var armed = false;
        timer = setTimeout(function () { armed = true; }, Math.max(2, amount) * 1000);
        listen(document, 'mouseout', function (event) {
          if (armed && event.clientY <= 0 && !event.relatedTarget) fire('exit');
        });
      } else if (rule.type === 'idle') {
        var reset = function () {
          clearTimeout(timer);
          timer = setTimeout(function () { fire('idle'); }, Math.max(1, amount) * 1000);
        };
        ['pointerdown', 'keydown', 'scroll'].forEach(function (name) { listen(window, name, reset); });
        reset();
      } else {
        timer = setTimeout(function () { fire('delay'); }, Math.max(1, amount) * 1000);
      }
    });
  }

  function safeHost(url) {
    try { return new URL(url).hostname; } catch (_) { return ''; }
  }

  function sessionId() {
    try {
      var value = sessionStorage.getItem(STORAGE_PREFIX + 'session');
      if (!value) {
        value = 's-' + Math.random().toString(36).slice(2) + Date.now().toString(36);
        sessionStorage.setItem(STORAGE_PREFIX + 'session', value);
      }
      return value;
    } catch (_) { return 'session'; }
  }

  function eventPayload(name, detail) {
    var campaign = activeCampaign || {};
    var params = new URLSearchParams(location.search);
    var context = bootstrap.context || {};
    var attributionContext = null;
    try { attributionContext = window.MisuAnalytics && window.MisuAnalytics.context(); } catch (_) {}
    var attribution = attributionContext && attributionContext.attribution || {};
    return {
      eventId: window.crypto && window.crypto.randomUUID ? window.crypto.randomUUID() : 'e-' + Math.random().toString(36).slice(2) + Date.now().toString(36),
      event: name,
      at: new Date().toISOString(),
      campaignId: campaign.id || 'unknown',
      template: campaign.template || 'offer',
      visitorId: visitorId(),
      sessionId: sessionId(),
      path: location.pathname.slice(0, 180),
      referrer: document.referrer ? safeHost(document.referrer) : '',
      device: isMobile() ? 'mobile' : 'desktop',
      country: context.country || '',
      utmSource: (params.get('utm_source') || '').slice(0, 80),
      landingPageId: context.landingPageId || 'default',
      utmCampaign: attribution.utm_campaign || '',
      creativeId: attribution.creative_id || attribution.utm_content || '',
      assignmentToken: assignmentToken || undefined,
      detail: safeDetail(detail)
    };
  }

  function queuedEvents() {
    return storageGet('eventQueue', []).map(function (event) { event.detail = safeDetail(event.detail); return event; });
  }

  function removeQueuedEvents(eventIds) {
    storageSet('eventQueue', queuedEvents().filter(function (event) { return eventIds.indexOf(event.eventId) === -1; }));
  }

  function sendBeaconBatch(events) {
    if (!analyticsAllowed() || !navigator.sendBeacon || !events.length || !bootstrap.endpoint) return;
    var url = String(bootstrap.endpoint).replace(/\/+$/, '') + '/api/popup-events?brand=misu';
    try {
      navigator.sendBeacon(url, new Blob([JSON.stringify(events)], { type: 'text/plain;charset=UTF-8' }));
    } catch (_) {}
  }

  function flushQueuedEvents() {
    if (deliveryInFlight || !analyticsAllowed() || !bootstrap.endpoint) return;
    var events = queuedEvents().slice(0, 12);
    if (!events.length) return;
    deliveryInFlight = true;
    var eventIds = events.map(function (event) { return event.eventId; });
    var url = String(bootstrap.endpoint).replace(/\/+$/, '') + '/api/popup-events?brand=misu';
    var controller = 'AbortController' in window ? new AbortController() : null;
    var timeout = setTimeout(function () { if (controller) controller.abort(); }, 8000);
    fetch(url, {
      method: 'POST',
      mode: 'cors',
      credentials: 'omit',
      keepalive: true,
      signal: controller ? controller.signal : undefined,
      // text/plain is CORS-safelisted, avoiding a fragile preflight on navigation.
      headers: { 'content-type': 'text/plain;charset=UTF-8' },
      body: JSON.stringify(events)
    }).then(function (response) {
      if (!response.ok) throw new Error('event_' + response.status);
      return response.json();
    }).then(function (receipt) {
      if (!receipt.ok || receipt.accepted !== events.length) throw new Error('event_not_acknowledged');
      clearTimeout(timeout);
      removeQueuedEvents(eventIds);
      deliveryInFlight = false;
      deliveryFailures = 0;
      if (queuedEvents().length) deliveryTimer = setTimeout(flushQueuedEvents, 120);
    }).catch(function () {
      clearTimeout(timeout);
      deliveryInFlight = false;
      deliveryFailures += 1;
      sendBeaconBatch(events);
      // Retry without requiring another click. Reuse IDs so a lost response
      // cannot double-count a view. After five failures, retry on next visit/online.
      if (deliveryFailures <= 5 && navigator.onLine !== false) {
        clearTimeout(deliveryTimer);
        deliveryTimer = setTimeout(flushQueuedEvents, Math.min(30000, 1000 * Math.pow(2, deliveryFailures - 1)));
      }
    });
  }

  function analyticsAllowed() {
    return !!(window.MisuPrivacy && window.MisuPrivacy.allowsAnalytics());
  }
  function safeDetail(detail) {
    var clean = {};
    ['source','reason','trigger','runtimeVersion','action','type'].forEach(function (key) {
      if (detail && typeof detail[key] === 'string' && /^[a-zA-Z0-9_. -]{1,60}$/.test(detail[key])) clean[key] = detail[key];
    });
    // Retain the selected choice for first-party popup reporting. The server
    // validates it against the published campaign or assigned test snapshot.
    ['value', 'intent'].forEach(function (key) {
      var value = detail && detail[key];
      if (typeof value === 'string' && value.trim() && value.length <= 160 && !/[@\x00-\x1f\x7f]|%40/i.test(value)) clean[key] = value;
    });
    if (clean.value) clean.step = ['Hot','Iced','Both','Still deciding'].indexOf(clean.value) !== -1 ? 'preparation_preference' : 'morning_goal';
    return clean;
  }
  function track(name, detail, preparedEvent) {
    if (!analyticsAllowed() || ALLOWED_EVENTS.indexOf(name) === -1 || !bootstrap.endpoint) return;
    var eventDetail = safeDetail(detail);
    var event = preparedEvent || eventPayload(name, eventDetail);
    event.detail = eventDetail;
    try {
      if (window.MisuAnalytics) window.MisuAnalytics.track('misu_popup_' + name, {
        popup_campaign_id: event.campaignId,
        trigger: eventDetail.trigger,
        action: eventDetail.action,
        reason: eventDetail.reason,
        error_code: eventDetail.type
      }, event.eventId);
    } catch (_) {}
    storageSet('eventQueue', queuedEvents().concat(event).slice(-50));
    clearTimeout(deliveryTimer);
    deliveryTimer = setTimeout(flushQueuedEvents, 80);
  }

  function offerHeaderHtml(content, emailStep) {
    return '<p class="misup-offer-kicker">' + escapeHtml(emailStep ? content.kicker : content.kicker) + '</p>' +
      '<h2 class="misup-offer-title">' + escapeHtml(emailStep ? content.emailTitle : content.title) + '</h2>' +
      '<p class="misup-offer-accent">' + escapeHtml(emailStep ? content.emailBody : content.titleAccent) + '</p>';
  }

  function introStepHtml(content) {
    var choices = (content.choices || []).slice(0, 4).map(function (choice) {
      return '<li><button class="misup-answer" type="button" data-answer="' + escapeHtml(choice) + '">' +
        '<span>' + escapeHtml(choice) + '</span></button></li>';
    }).join('');
    return '<section class="misup-step is-active" data-step="intro">' +
      offerHeaderHtml(content, false) +
      '<p class="misup-question">' + escapeHtml(content.question) + '</p>' +
      '<ul class="misup-answers">' + choices + '</ul>' +
      '</section>';
  }

  function emailStepHtml(content) {
    return '<section class="misup-step" data-step="email">' +
      offerHeaderHtml(content, true) +
      '<form class="misup-form" data-email-form novalidate>' +
      '<label class="misup-label" for="MisuPopupEmail">Your email address</label>' +
      '<input id="MisuPopupEmail" name="email" type="email" inputmode="email" autocomplete="email" placeholder="Your email address" required>' +
      '<div hidden aria-hidden="true"><label>Website<input name="website" type="text" tabindex="-1" autocomplete="off"></label></div>' +
      '<button class="misup-submit" type="submit">UNLOCK MY OFFER</button>' +
      '<p class="misup-consent">Misu emails only. Unsubscribe anytime.</p>' +
      '<p class="misup-error" data-email-error role="alert"></p>' +
      '</form>' +
      '</section>';
  }

  function successStepHtml(content) {
    return '<section class="misup-step misup-success" data-step="success">' +
      '<h2 class="misup-success-title">' + escapeHtml(content.successTitle) + '</h2>' +
      '<div class="misup-reward">' +
      '<strong>' + escapeHtml(content.emailTitle) + '</strong>' +
      '<span>' + escapeHtml(content.emailBody) + '</span>' +
      '</div>' +
      '<button class="misup-cta" type="button" data-offer-cta>' +
      escapeHtml(content.cta) + '</button>' +
      '</section>';
  }

  function sparkleHtml(className) {
    return '<svg class="' + className + '" viewBox="0 0 66 58" aria-hidden="true">' +
      '<path d="M14 2c1.5 8 5 11.5 13 13-8 1.5-11.5 5-13 13C12.5 20 9 16.5 1 15 9 13.5 12.5 10 14 2Z"></path>' +
      '<path d="M45 9c1.8 10 6 14.2 16 16-10 1.8-14.2 6-16 16-1.8-10-6-14.2-16-16 10-1.8 14.2-6 16-16Z"></path>' +
      '<path d="M17 35c1.6 8.7 5.3 12.4 14 14-8.7 1.6-12.4 5.3-14 14-1.6-8.7-5.3-12.4-14-14 8.7-1.6 12.4-5.3 14-14Z"></path>' +
      '</svg>';
  }

  function prepareGame(campaign) {
    if (!campaign.game || window.MisuPopupGame) return Promise.resolve();
    return new Promise(function (resolve) {
      var script = document.createElement('script');
      // Liquid supplies the game's own CDN version, independently of this runtime.
      // Keep old/cached bootstrap documents safe during a staggered deployment.
      var gameUrl = new URL((bootstrap.assets || {}).game || 'misu-popup-game.js', runtimeUrl || location.href);
      if (!gameUrl.searchParams.has('v')) gameUrl.searchParams.set('v', VERSION);
      script.src = gameUrl.href;
      var done = false;
      function finish() { if (done) return; done = true; clearTimeout(timer); resolve(); }
      var timer = setTimeout(finish, 1800);
      script.onload = finish;
      script.onerror = finish;
      document.head.appendChild(script);
    });
  }

  function shellHtml(campaign) {
    var content = campaign.content || DEFAULT_CONFIG.campaigns[0].content;
    var logo = escapeHtml((bootstrap.assets || {}).logo || '');
    return '<div class="misup-shell__veil" aria-hidden="true"></div>' +
      '<div class="misup-stage" aria-hidden="true"></div>' +
      '<button class="misup-close" type="button" data-dismiss aria-label="Close">' +
      '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="m5 5 14 14M19 5 5 19"></path></svg></button>' +
      '<section class="misup-dialog" tabindex="-1">' +
      '<span class="misup-sr-only" id="MisuPopupTitle">Misu first box offer</span>' +
      sparkleHtml('misup-sparkle misup-sparkle--top') +
      sparkleHtml('misup-sparkle misup-sparkle--bottom') +
      '<div class="misup-card-content">' +
      '<div class="misup-brand"><img class="misup-logo" src="' + logo + '" alt="Misu" width="128" height="52"></div>' +
      '<div class="misup-steps">' +
      (campaign.game && window.MisuPopupGame ? window.MisuPopupGame.html(campaign) : '') + introStepHtml(content) +
      emailStepHtml(content) +
      successStepHtml(content) +
      '</div></div></section>';
  }

  function lockPage(shell) {
    var root = document.documentElement;
    var body = document.body;
    var scroll = { x: window.scrollX, y: window.scrollY };
    var previousFocus = document.activeElement;
    var previousTop = body.style.getPropertyValue('--misup-scroll-top');
    var previousTopPriority = body.style.getPropertyPriority('--misup-scroll-top');
    var previousScrollBehavior = root.style.getPropertyValue('scroll-behavior');
    var previousScrollPriority = root.style.getPropertyPriority('scroll-behavior');
    var rootWasLocked = root.classList.contains('misup-open');
    var bodyWasLocked = body.classList.contains('misup-open');
    root.style.setProperty('scroll-behavior', 'auto', 'important');
    body.style.setProperty('--misup-scroll-top', -scroll.y + 'px');
    root.classList.add('misup-open');
    body.classList.add('misup-open');
    function fitViewport() {
      var viewport = window.visualViewport;
      shell.style.setProperty('--mp-vheight', (viewport ? viewport.height : innerHeight) + 'px');
      shell.style.setProperty('--mp-vwidth', (viewport ? viewport.width : innerWidth) + 'px');
      shell.style.setProperty('--mp-vtop', (viewport ? viewport.offsetTop : 0) + 'px');
      shell.style.setProperty('--mp-vleft', (viewport ? viewport.offsetLeft : 0) + 'px');
    }
    fitViewport();
    addEventListener('resize', fitViewport);
    if (window.visualViewport) {
      visualViewport.addEventListener('resize', fitViewport);
      visualViewport.addEventListener('scroll', fitViewport);
    }
    return function () {
      removeEventListener('resize', fitViewport);
      if (window.visualViewport) {
        visualViewport.removeEventListener('resize', fitViewport);
        visualViewport.removeEventListener('scroll', fitViewport);
      }
      if (!bodyWasLocked) body.classList.remove('misup-open');
      if (!rootWasLocked) root.classList.remove('misup-open');
      if (previousTop) body.style.setProperty('--misup-scroll-top', previousTop, previousTopPriority);
      else body.style.removeProperty('--misup-scroll-top');
      if (previousFocus && previousFocus.isConnected) previousFocus.focus({ preventScroll: true });
      // Restore after layout and focus, bypassing the storefront's smooth scrolling.
      window.scrollTo({ left: scroll.x, top: scroll.y, behavior: 'instant' });
      if (previousScrollBehavior) root.style.setProperty('scroll-behavior', previousScrollBehavior, previousScrollPriority);
      else root.style.removeProperty('scroll-behavior');
    };
  }

  function openPopup(campaign, triggerType) {
    if (opened || !campaign) return;
    opened = true;
    activeCampaign = campaign;
    var frequencyKey = (campaign.game || {}).controlId || campaign.id;
    var history = storageGet('history.' + frequencyKey, []);
    history.push(Date.now());
    storageSet('history.' + frequencyKey, history.slice(-10));
    var shell = document.createElement('dialog');
    shell.className = 'misup-shell';
    shell.setAttribute('aria-labelledby', 'MisuPopupTitle');
    shell.dataset.template = 'offer';
    shell.dataset.motion = (campaign.design || {}).motion || 'slide';
    shell.style.setProperty('--mp-accent', safeColor((campaign.design || {}).accent, '#352116'));
    shell.style.setProperty('--mp-surface', safeColor((campaign.design || {}).surface, '#FBF3DF'));
    shell.style.setProperty('--mp-scale', String(Math.max(76, Math.min(94, Number((campaign.design || {}).scale || 88))) / 100));
    shell.innerHTML = shellHtml(campaign);
    if (campaign.game && window.MisuPopupGame) {
      shell.dataset.game = 'match-three';
      shell.dataset.step = 'game';
      shell.querySelector('[data-step="intro"]').classList.remove('is-active');
      shell.querySelector('[data-step="game"]').classList.add('is-active');
    }
    document.body.appendChild(shell);
    var unlockPage = lockPage(shell);
    shell.showModal();
    bindPopup(shell, campaign, unlockPage);
    requestAnimationFrame(function () {
      requestAnimationFrame(function () { shell.classList.add('is-open'); });
    });
    setTimeout(function () {
      if (shell.isConnected && !shell.dataset.step) shell.dataset.step = 'intro';
    }, 820);
    var dialog = shell.querySelector('.misup-dialog');
    if (dialog) dialog.focus({ preventScroll: true });
    track('impression', {
      trigger: triggerType || (campaign.trigger || {}).type || 'delay',
      runtimeVersion: VERSION
    });
    if (campaign.game && !window.MisuPopupGame) track('error', { type: 'game_load_fallback' });
  }

  function showStep(shell, name) {
    var current = shell.querySelector('.misup-step.is-active');
    var next = shell.querySelector('[data-step="' + name + '"]');
    if (!next || current === next) return;
    if (current) current.classList.add('is-leaving');
    setTimeout(function () {
      if (!shell.isConnected || shell.dataset.closing) return;
      if (current) current.classList.remove('is-active', 'is-leaving');
      next.classList.add('is-active');
      shell.dataset.step = name;
    }, name === 'success' ? 60 : 140);
  }

  function subscribe(email, campaign, intent, website, analyticsEvent) {
    if (!bootstrap.endpoint) return Promise.reject(new Error('signup_unavailable'));
    return fetch(String(bootstrap.endpoint).replace(/\/+$/, '') + '/api/popup-subscribe?brand=misu', {
      method: 'POST',
      mode: 'cors',
      credentials: 'omit',
      signal: AbortSignal.timeout(25000),
      // The endpoint accepts JSON text; a simple request avoids a CORS round trip.
      headers: { 'content-type': 'text/plain;charset=UTF-8' },
      body: JSON.stringify({ brandId: 'misu', email: email, campaignId: campaign.id, intent: intent, question: campaign.content.question, analyticsEvent: analyticsEvent, captureId:analyticsEvent && analyticsEvent.eventId, assignmentToken:assignmentToken || undefined, analyticsConsent:analyticsAllowed(), consent: true, website: website || '' })
    }).then(function (response) {
      return response.json().then(function (payload) {
        if (!response.ok || payload.ok !== true || payload.destination !== 'shopify_customers') throw new Error(payload.error || 'signup_failed');
        return payload;
      });
    });
  }

  function bindPopup(shell, campaign, unlockPage) {
    var intent = '';
    var engaged = false;
    var stopGame = function () {};
    if (campaign.game && window.MisuPopupGame) stopGame = window.MisuPopupGame.bind(shell, campaign, {
      track: track,
      next: function () {
        showStep(shell, 'intro');
        setTimeout(function () { if (shell.isConnected) shell.querySelector('[data-answer]').focus({ preventScroll: true }); }, 160);
      }
    });
    var dialog = shell.querySelector('.misup-dialog');
    var dismiss = function (reason) {
      if (!shell.isConnected || shell.dataset.closing) return;
      shell.dataset.closing = 'true';
      stopGame();
      // Explicit dismissal is immediate; tracking must never hold the modal open.
      shell.close();
      shell.remove();
      unlockPage();
      track('dismissed', { reason: reason || 'close' });
    };
    shell.addEventListener('cancel', function (event) { event.preventDefault(); dismiss('escape'); });

    shell.querySelectorAll('[data-dismiss]').forEach(function (button) {
      button.addEventListener('click', function () {
        dismiss('close');
      });
    });

    shell.addEventListener('click', function (event) {
      if (!engaged && event.target.closest('[data-game-card], [data-answer], [data-email-form], [data-offer-cta]')) {
        engaged = true;
        track('engaged', { action: 'click' });
      }
    });

    document.addEventListener('keydown', function onKeydown(event) {
      if (!shell.isConnected) {
        document.removeEventListener('keydown', onKeydown);
        return;
      }
      if (event.key !== 'Tab') return;
      var focusable = [].slice.call(shell.querySelectorAll(
        'button:not([disabled]),a[href],input:not([disabled]),[tabindex]:not([tabindex="-1"])'
      )).filter(function (element) { return element.offsetParent !== null; });
      if (!focusable.length) return;
      var first = focusable[0];
      var last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });

    shell.querySelectorAll('[data-answer]').forEach(function (button) {
      button.addEventListener('click', function () {
        if (intent) return;
        intent = button.dataset.answer || '';
        shell.querySelectorAll('[data-answer]').forEach(function (answer) {
          answer.disabled = true;
          answer.classList.toggle('is-selected', answer === button);
          answer.classList.toggle('is-muted', answer !== button);
        });
        track('step_completed', { value: intent });
        setTimeout(function () {
          showStep(shell, 'email');
          setTimeout(function () {
            var email = shell.querySelector('[type="email"]');
            if (email && shell.isConnected && !shell.dataset.closing && shell.dataset.step === 'email') email.focus({ preventScroll: true });
          }, 220);
        }, 120);
      });
    });

    var form = shell.querySelector('[data-email-form]');
    if (form) {
      form.querySelector('[type="email"]').addEventListener('input', function (event) {
        event.target.removeAttribute('aria-invalid');
        form.querySelector('[data-email-error]').textContent = '';
      });
      form.addEventListener('submit', function (event) {
        event.preventDefault();
        var input = form.querySelector('[type="email"]');
        var error = form.querySelector('[data-email-error]');
        var submit = form.querySelector('[type="submit"]');
        if (submit.disabled) return;
        var email = (input.value || '').trim();
        if (!input.checkValidity() || email.length > 254 || !/^[^\s@<>]+@[^\s@<>]+\.[^\s@<>]+$/.test(email)) {
          error.textContent = 'Enter a valid email address.';
          input.setAttribute('aria-invalid', 'true');
          input.focus();
          return;
        }
        error.textContent = '';
        submit.disabled = true;
        submit.textContent = 'SAVING…';
        var captureDetail = { source: 'shopify_customers', intent:intent };
        var capture = !analyticsAllowed() ? null : eventPayload('email_submitted', captureDetail);
        subscribe(email, campaign, intent, form.elements.website.value, capture).then(function (receipt) {
          if (receipt && receipt.mailroomIdentity) window.dispatchEvent(new CustomEvent('misu:mailroom-identity', { detail: { token: receipt.mailroomIdentity } }));
          storageSet('convertedAt', Date.now());
          try {
            if (window.MisuPrivacy && window.MisuPrivacy.allowsMarketing() && window.Shopify && Shopify.analytics && typeof Shopify.analytics.visitor === 'function') {
              Shopify.analytics.visitor({ email: email });
            }
          } catch (_) {}
          track('email_submitted', captureDetail, capture);
          showStep(shell, 'success');
          setTimeout(function () {
            var cta = shell.querySelector('[data-offer-cta]');
            if (cta && shell.isConnected && !shell.dataset.closing) cta.focus({ preventScroll: true });
          }, 100);
        }).catch(function (failure) {
          error.textContent = failure.message === 'too_many_attempts' ? 'Too many attempts. Please try again in a few minutes.' : 'We couldn’t save that yet. Please try again.';
          submit.disabled = false;
          submit.textContent = 'UNLOCK MY OFFER';
          track('error', { type: 'email_submit' });
        });
      });
    }

    var cta = shell.querySelector('[data-offer-cta]');
    if (cta) {
      cta.addEventListener('click', function (event) {
        event.preventDefault();
        dismiss('offer_complete');
        track('cta_clicked', { action: 'close' });
      });
    }
  }

  function boot() {
    loadConfig().then(function (config) {
      if(!config)return;
      if (!config.enabled && !forceOpen) return;
      if(activeExperiment && !forceOpen) {
        if(activeExperiment.status!=='running')return;
        return fetch(String(bootstrap.endpoint).replace(/\/+$/,'')+'/api/popup-assignment?brand=misu',{
          method:'POST',headers:{'Content-Type':'text/plain;charset=UTF-8'},signal:AbortSignal.timeout(5000),
          body:JSON.stringify({visitorId:visitorId(),experimentId:activeExperiment.id})
        }).then(function(r){if(!r.ok)throw new Error('assignment_unavailable');return r.json();}).then(function(payload){
          if(!payload.assignment)return;
          assignmentToken=payload.assignment.token;
          var campaign=Object.assign({},payload.assignment.campaign,{enabled:true,weight:100});
          if(eligible(campaign))schedule(campaign);
        }).catch(function(){});
      }
      schedule(chooseCampaign(config));
    });
  }

  addEventListener('misu:privacy-changed', function () { if (!analyticsAllowed()) { storageSet('eventQueue', []); clearTimeout(deliveryTimer); } else flushQueuedEvents(); });
  addEventListener('online', function () { deliveryFailures = 0; flushQueuedEvents(); });
  document.addEventListener('visibilitychange', function () {
    if (document.hidden) sendBeaconBatch(queuedEvents().slice(0, 12));
    else { deliveryFailures = 0; flushQueuedEvents(); }
  });
  addEventListener('pagehide', function () { sendBeaconBatch(queuedEvents().slice(0, 12)); });

  if ('requestIdleCallback' in window) requestIdleCallback(boot, { timeout: 1400 });
  else if (document.readyState === 'complete') setTimeout(boot, 1);
  else addEventListener('load', function () { setTimeout(boot, 1); }, { once: true });
})();
